module.exports = require("core-js-pure/stable/promise");